import type { ReactNode } from 'react';
import { PROGRAM_RULES } from '../prizeDrawConstants';

const renderRuleText = (rule: (typeof PROGRAM_RULES)[number]) => {
  let remaining = rule.text;
  const parts: ReactNode[] = [];

  rule.keyPhrases.forEach((phrase, index) => {
    const pos = remaining.indexOf(phrase);
    if (pos === -1) return;
    if (pos > 0) parts.push(remaining.slice(0, pos));
    parts.push(
      <span key={`${phrase}-${index}`} className='sv-rule-key'>
        {phrase}
      </span>
    );
    remaining = remaining.slice(pos + phrase.length);
  });

  if (remaining) parts.push(remaining);
  return parts.length > 0 ? parts : rule.text;
};

export const ProgramRulesCard = () => (
  <div id='sv-program-rules'>
    <div className='sv-rules-card'>
      <div className='sv-rules-hdr'>
        <div className='sv-rules-bar' />
        <h3 className='sv-rules-title'>Program rules</h3>
      </div>
      <div className='sv-rules-list'>
        {PROGRAM_RULES.map((rule, index) => (
          <div key={rule.text} className='sv-rule-row'>
            <div className='sv-rule-num'>{index + 1}</div>
            <div className='sv-rule-txt'>{renderRuleText(rule)}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
